import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { EmptyState } from "../components/ui";
import ChatList from "../components/chat/ChatList";
import ChatRoom from "../components/chat/ChatRoom";
import "../styles/chat.css";

/** /chat = รายการห้อง (มือถือเต็มจอ) ; /chat/:chatId = รายการ | ห้อง | แผงข้อมูล (desktop) */
export default function Chat() {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const [bump, setBump] = useState(null); // ห้องแชทแจ้งว่ามีข้อความใหม่/เปลี่ยนชื่อ -> รายการแก้เองโดยไม่ยิง API ซ้ำ

  return (
    <div className="chat-layout">
      <div className={chatId ? "hide-mobile" : ""} style={{ display: "contents" }}>
        <ChatList activeId={chatId} full={!chatId} bump={bump} onRemoved={() => navigate("/chat")} />
      </div>
      {chatId ? (
        <ChatRoom key={chatId} chatId={chatId} onChanged={(patch) => setBump({ ...patch, n: Date.now() })} onGone={() => navigate("/chat", { replace: true })} />
      ) : (
        <div className="chat-room chat-room--empty hide-mobile">
          <EmptyState icon="💬" title="เลือกห้องแชทเพื่อเริ่มคุย" action={<Link to="/" className="btn btn--primary">เลือกตัวละครใหม่</Link>}>หรือเริ่มแชทใหม่จากหน้าแรก</EmptyState>
        </div>
      )}
    </div>
  );
}
